import {Expression} from '../../../../service/Expression'
import {EventEmitter} from '../../../mixins/eventHandler'
import {ModifierThemeBin} from './thematicBuilder'
import {ColorPalette} from '../../../mixins/colorPalette'
import mapActions from '../../MapActions'
import expressionUtils from '../../../util/Expression'
import messenger from '../../../messenger/messenger'

class ThemeFactory {
  constructor () {
    this.emitter = new EventEmitter()
    this.expressionService = Expression.build({})
    const colorPalette = new ColorPalette()
    this.colorBrewerGroups = colorPalette.colorBrewerGroups()
    this.colorBrewerPallete = colorPalette.colorBrewerPalettes()
    this.colorBrewerColors = []
  }

  _recomputeColor (columnName, colors = [], buckets = [], isNumeric = true, featureState = true) {
    try {
      const modifierThemeBin = new ModifierThemeBin()
      const stops = modifierThemeBin.createBins2(buckets, colors)
      const foreColor = isNumeric
        ? modifierThemeBin.createFillColor(columnName, stops, featureState)
        : modifierThemeBin.createCategoricalFillColor(columnName, stops, featureState)
      return foreColor
    } catch (e) {
      console.log(`recomputeStyles: ${e}`)
      messenger.warn({position: 'top-end', title: e.message})
    }
  }

  /**
   *
   * @param {string} layer Layer identifier
   * @param {string} nativeType Mapbox layer type
   * @param {object} expression Expression instance
   * @param {object} options Theme options
   * @constructor
   */
  RangedTheme (layer, nativeType, expression, options) {
    try {
      const self = this
      const expressionId = expression.targetId || expression.id || expression.objectId
      if (expressionUtils.isNumericType(expression)) {
        const layerId = options.layerId
        const colorScheme = options.colorScheme
        const binCount = options.binCount
        const model = {
          'aggregation': options.aggregation,
          'where': layer,
          'expressions': expression.hasOwnProperty('child') ? expression.child : [],
          'zoom': options.zoom,
          "useAlias":false,
          "useInternalNames":true
        }
        this.expressionService.getBuckets(expressionId, options.binCount, options.method, model).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            const bins = res.data
            const topVariable = []
            let buckets = []
            let minBuckets = []
            let maxBuckets = []
            const colors = self.colorBrewerPallete[colorScheme][binCount]
            bins.forEach(function (bin, index) {
              const element = {
                data: bin,
                value: bin,
                isVisible: true,
                min: bin.range[0],
                max: bin.range[1],
                bins: binCount,
                type: expression.dataType,
                color: colors[index]
              }
              topVariable.push(element)
              minBuckets.push(element.min)
              maxBuckets.push(element.max)
            })
            buckets = [minBuckets,maxBuckets]
            const unique = Array.from(new Set(buckets))
            if (buckets.length !== unique.length) {
              messenger.error({position: 'center', title: 'Resultado possui duplicatas'})
              return false
            }
            this.emitter.trigger('recomputeBins', {layerId: layerId, buckets: buckets, topVariable: topVariable})
            this.emitter.trigger('topnColorChange', {layerId: layerId, buckets: buckets, topVariable: topVariable})
            const fillColor = self._recomputeColor(expressionUtils.getColumnName(expression), colors, buckets, true, false)
            const options = {
              mapKey: 'baseMap',
              layerId: `${nativeType}-${layer}`,
              key: `${nativeType}-color`,
              value: fillColor
            }
            mapActions.changePaintProperty(options)
          } else {
            const message = res.data.message || res.data.msg || res.data
            console.log(message)
          }
        })
      } else {
        /* CASO EXPRESSION SEJA ORDINAL ou CATEGÓRICA */
        // TODO Implementar categóricas/ordinais (Ferraz)
      }
    } catch (e) {
      console.log(e)
    }
  }
}

const instance = new ThemeFactory()
Object.freeze(instance)
export default instance
